<!-- <nav class="navbar navbar-expand-lg bg-primary navbar-transparent navbar-absolute" color-on-scroll="500">
  <div class="container">
    <div class="navbar-wrapper mx-auto">
      <a class="navbar-brand d-block d-sm-block d-md-block">
        FastLane
      </a>
    </div>
  </div>
</nav> -->

<router-outlet></router-outlet>